import selectInsurance from 'utils/selectInsurance';
import getPatientDob2 from 'utils/print/getPatientDob2';

const getInsuranceInsuredsDob2 = ({ patient, insurance, value, ...otherProps }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const selectedInsurance = insurance || selectInsurance(patient['Insurance Information']);
  const selectedInsuranceRelationToInsured = selectedInsurance
    ? selectedInsurance['Relation to Insured']
    : 'none';
  switch (selectedInsuranceRelationToInsured) {
    case 'Self':
      return getPatientDob2({
        ...otherProps,
        patient,
        insurance,
      });
    case 'Spouse':
    case 'Child':
    case 'Other':
      return selectedInsurance['Related Date of Birth']
        ? selectedInsurance['Related Date of Birth'].replace(/[/]/g, '').substring(2, 4)
        : null;
    default:
      return null;
  }
};

export default getInsuranceInsuredsDob2;



// WEBPACK FOOTER //
// ./src/utils/print/getInsuranceInsuredsDob2.js